import DoAPICall from './DoAPICall'

//Create Client
    export async function createClient(userToken, client){
        const apiPayload = {
            httpMethod:'post',
            userToken,
            uri:'clients',
            payLoad:{
                shortCode:client.shortCode,
                shortName:client.shortName,
                urlPrefix:client.urlPrefix,
                ussdAggregator:client.ussdAggregator,
                name:client.name,
                ussdMenuText:client.ussdMenuText,
                ussdRootPrompt:client.ussdRootPrompt,
                mode:client.mode,
                testMSISDN:client.testMSISDN,
                smsPayMode:client.smsPayMode,
                balance:client.balance,
                surcharge:client.surcharge,
                status:client.status
            },
            requestOptions:{}
        }
        return await DoAPICall(apiPayload)
    }

//Get All client
    export async function getClients(userToken){
        const apiPayload = {
            httpMethod:'get',
            userToken,
            uri:'clients',
            payLoad:{},
            requestOptions:{}
        }
        return await DoAPICall(apiPayload)
    }

//Get All Aggregators
export async function getAggregators(userToken){
    const apiPayload = {
        httpMethod:'get',
        userToken,
        uri:'clients?ussdAggregator=YES',
        payLoad:{},
        requestOptions:{}
    }
    return await DoAPICall(apiPayload)
}

//Get One client
    export async function getClient(userToken, id){
        const apiPayload = {
            httpMethod:'get',
            userToken,
            uri:'clients/'+id,
            payLoad:{},
            requestOptions:{}
        }
        return await DoAPICall(apiPayload)
    }

    export async function getWebPaymentClient(urlPrefix){
        const apiPayload = {
            httpMethod:'get',
            uri:'app/webpaymentsclients?urlPrefix='+urlPrefix,
            payLoad:{},
            requestOptions:{}
        }
        return await DoAPICall(apiPayload)
    }

//Update client
    export async function updateClient(userToken, client){
        const apiPayload = {
            httpMethod:'put',
            userToken,
            uri:'clients/'+client.id,
            payLoad:{
                ussdAggregator:client.ussdAggregator,
                shortCode:client.shortCode,
                shortName:client.shortName,
                urlPrefix:client.urlPrefix,
                name:client.name,
                ussdMenuText:client.ussdMenuText,
                ussdRootPrompt:client.ussdRootPrompt,
                mode:client.mode,
                testMSISDN:client.testMSISDN,
                smsPayMode:client.smsPayMode,
                balance:client.balance,
                surcharge:client.surcharge,
                status:client.status
            },
            requestOptions:{}
        }
        return await DoAPICall(apiPayload)
    }

//Delete client (by updating the status)
    export async function deleteClient(userToken, client){
        const apiPayload = {
            httpMethod:'put',
            userToken,
            uri:'clients/'+client.id,
            payLoad:{
                status:client.status,
            },
            requestOptions:{}
        }
        return await DoAPICall(apiPayload)
    }



  